
import React from 'react';
import { makeProjectsActionType } from '../../state/action';
import './no_projects.scss';

interface NoProjectsComponentProps {
    state: makeProjectsActionType;
	heading: string;
	bodyText: string;
	children: any
}

const NoProjectsComponent:React.FC<NoProjectsComponentProps> = (props) => {


	let classNames = props.state != 'deleted' ? "columns text-center noprojmsg" : "columns text-center"

    return (<div className="row noProjectsDiv"  style={{display: "block"}}>
	<div className={classNames}>
	    <p className="pro_title">
		    {props.heading}
	    </p>
	    <p>
		    {props.bodyText}
	    </p>
        {
         (props.state != 'deleted') ?
			<>
			{/** @ts-ignore */}
	        <a className="start-project" sqatid="start_project" href={`${ photoOrg.config.store_url}${ photoOrg.config.no_proj_url }`} role="button">{ photoOrg.translations.projects["get_started"]}</a>
            </>: null
        }
	</div>
	<div className="no-product-response-sec" style={{display: "none"}}>
		{/** @ts-ignore */}
	    <span>{ photoOrg.translations.projects["failed_projects_to_load_txt"] } </span>
	</div>
</div>)
}

export default NoProjectsComponent;